import { render, staticRenderFns } from "./InvoicesToApprove.vue?vue&type=template&id=1b093fca&scoped=true&"
import script from "./InvoicesToApprove.vue?vue&type=script&lang=js&"
export * from "./InvoicesToApprove.vue?vue&type=script&lang=js&"
import style0 from "./InvoicesToApprove.vue?vue&type=style&index=0&id=1b093fca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b093fca",
  null
  
)

export default component.exports